var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "move-down-dialog",
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.title,
        "close-on-click-modal": false,
        width: "20%"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c("span", [
        _c("i", { staticClass: "el-icon-warning icon-tip" }),
        _vm._v(_vm._s(_vm.message))
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.click(2)
                }
              }
            },
            [_vm._v(_vm._s(_vm.button2))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.click(1)
                }
              }
            },
            [_vm._v(_vm._s(_vm.button1))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.click(3)
                }
              }
            },
            [_vm._v(_vm._s(_vm.button3))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }